/**
 *  Deprecated Feb. 17, 2021 - Please make updates in react version
 *
 */

/**
 *
 * @name app.module.HeaderDirective
 * @copyright 2015 Empower Retirement
 * @require angular
 * @description Directive responsible for the Site Header
 *
 */
import headerTemplate from "./headerTemplate";
import ExternalLogger from "../../../logger/ExternalLogger";

var translateService = null;
var httpProvider = null;
var accuCodeService = null;
var logger = ExternalLogger.getInstance('HeaderDirective');
var googleAnalyticsId = "GTM-MBZH2H"; // default

var HeaderDirective = function (transService, $http, AccuCodeService) {
    translateService = transService;
    httpProvider = $http;
    accuCodeService = AccuCodeService

    var directive = {
        restrict: "E",
        controller: "HeaderController",
        scope: true,
        template: headerTemplate,
        link: initializeHeader
    };

    return directive;
};

var initializeHeader = function(scope, element, attrs) {

    scope.showBalanceInTabletAndPhone = String(attrs.showBalanceInTabletAndPhone) === "true";

    var method = "initializeHeader()";

    logger.debug("{0}- Enter method.", [method]);

    scope.availableLocales = translateService.availableLocales;
    scope.showChangeLanguageButton = scope.availableLocales.length > 1;
    scope.setLocale = translateService.setLocale;

    var envCfgPath = "/participant_env.json";

    httpProvider.get(envCfgPath)
        .then(function(response) {
            var accuCode = accuCodeService.getAccuCode();
            var data = response.data;

            logger.debug("{0}- Current ACCU [{1}]", [method, accuCode]);
            const currentHost = window.location.host;
            const devEnvRegex = /(proj\d+)|(uat\d+)|(cte\d+)|(cdemo\d+)|(aws\.gwl\.com)|(^uat)|(qa)|(evaluate\d+)/i; // if domain is proj[0-n] or uat[0-n] or cte[0-n] or cdemo[0-n] aws.gwl.com case insensitive
            let useDevAnalyticsId = devEnvRegex.test(currentHost);

            if (data.analytics && data.analytics["googleAnalyticsId.dev"] && useDevAnalyticsId) {
                googleAnalyticsId = data.analytics["googleAnalyticsId.dev"];
                logger.debug('{0}- Found DEV AnalyticsId [{1}] value=[{2}]', [method, envCfgPath, googleAnalyticsId]);
            } else if (data.analytics && data.analytics["googleAnalyticsId." + accuCode]){
                googleAnalyticsId = data.analytics["googleAnalyticsId." + accuCode];
                logger.debug("{0}- Found ACCU-LEVEL AnalyticsId [{1}] value=[{2}]", [method, envCfgPath, googleAnalyticsId]);
            } else if (data.analytics && data.analytics.googleAnalyticsId){
                googleAnalyticsId = data.analytics.googleAnalyticsId;
                logger.debug("{0}- Found [{1}] value=[{2}]", [method, envCfgPath, googleAnalyticsId]);
            }

            prependToHead(createScripElement());
            prependToBody(createNoScriptElement());
        }, function(response) {
            logger.debug('{0}-  Error retrieving env config. [{1}] status=[{2}] response=[{3}]', [method, envCfgPath,response.status, JSON.stringify(response)]);
            prependToHead(createScripElement());
            prependToBody(createNoScriptElement());
       });

}; //End of initializeHeader function



/*
    ###########################################################
    # INTENTIONALLY CHOSE TO PUT THIS HERE INSTEAD OF HTML
    # (html may be in templateCache depending on build)
    ###########################################################
*/
function createScripElement(){
    var element = document.createElement("script");
    element.type = "text/javascript";

    // var code = ""
    // + "     (function (w, d, s, l, i) { "
    // + "         w[l] = w[l] || []; "
    // + "         w[l].push( "
    // + "                 {'gtm.start': new Date().getTime(), event: 'gtm.js'}  "
    // + "         ); "
    // + "         var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; "
    // + "         j.async = true; "
    // + "         j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl; "
    // + "         f.parentNode.insertBefore(j, f); "
    // + "     })(window, document, 'script', 'dataLayer', '"
    // + googleAnalyticsId
    // + "'); ";

    var code = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" + googleAnalyticsId + "');";

    angular.element(element).append(document.createTextNode(code));

    return element;
}

function createNoScriptElement(){
    // var tag = " <noscript> "
    //     + '     <iframe src="//www.googletagmanager.com/ns.html?id='
    //     + googleAnalyticsId
    //     + '" height="0" width="0" style="display:none;visibility:hidden"></iframe> '
    //     + " </noscript> ";

    var tag = '<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=' + googleAnalyticsId + '" height="0" width="0" style="display:none visibility:hidden"></iframe></noscript>';

    return tag;
}

function prependToHead(elem){
    if(!elem){
        return;
    }

    var head = angular.element(document.querySelector("head"));
    if(!head){
        return;
    }

    head.prepend(angular.element(elem));
}

function prependToBody(elem){
    if(!elem){
        return;
    }

    var body = angular.element(document.querySelector("body"));
    if(!body){
        return;
    }

    body.append(angular.element(elem));
}

HeaderDirective.$inject = ['translateService', '$http', 'AccuCodeService'];

export default HeaderDirective;
